import { MdKeyboardArrowLeft as LeftArrowIcon } from 'react-icons/md'

export default LeftArrowIcon;
